import { SxProps } from '@mui/system';

export const root: SxProps = {
  marginBottom: '2px',
};

export const buttonsContainer: SxProps = {
  justifyContent: 'space-between',
  alignItems: 'center',
  flex: 1,
  marginLeft: '4px',
};

export const titleContainer: SxProps = {
  alignItems: 'center',
  flex: 1,
};
